import React from 'react'
import { parse } from 'subtitle'
import { AudioContext } from './AudioContext'
import { Icon } from './shared'
import styles from './AudioPlayer.module.css'
import { icons, convertSeconds, getPercent, between } from './helpers'

class PlayerControls extends React.Component {
  static contextType = AudioContext

  static defaultOptions = {
    autoplay: false,
    progress: true,
    time: false,
    volume: false,
  }

  state = {
    loaded: false,
    playing: false,
    ended: false,
    muted: false,
    currentTime: 0,
    progress: 0,
    duration: 0,
    subtitle: null,
  }

  _isMounted = false

  componentDidMount() {
    this._isMounted = true
    this.loadSubtitle()

    this.audio = this.context.addToPlaylist(this.props.source)
    // this.audio.addEventListener('loadstart', this.onLoadStart)
    this.audio.addEventListener('canplaythrough', this.onCanPlay)
    this.audio.addEventListener('play', this.onPlay)
    this.audio.addEventListener('pause', this.onPause)
    this.audio.addEventListener('timeupdate', this.onTimeUpdate)
    this.audio.addEventListener('ended', this.onEnded)

    if(this.options.autoplay) {
      this.audio.play()
    }
  }

  componentWillUnmount() {
    this._isMounted = false

    this.context.unmount(this.props.source)
    // this.audio.removeEventListener('loadstart', this.onLoadStart)
    this.audio.removeEventListener('canplaythrough', this.onCanPlay)
    this.audio.removeEventListener('play', this.onPlay)
    this.audio.removeEventListener('pause', this.onPause)
    this.audio.removeEventListener('timeupdate', this.onTimeUpdate)
    this.audio.removeEventListener('ended', this.onEnded)
  }

  get options() {
    return {
      ...PlayerControls.defaultOptions,
      ...this.props.options,
    }
  }

  loadSubtitle = () => {
    if(!this.props.subtitle) return

    fetch(this.props.subtitle)
      .then(res => res.text())
      .then(text  => {
        this.setState({
          loaded: true,
          subtitle: parse(text),
        })
      })
  }

  onCanPlay = e => {
    if(!this._isMounted) return

    this.setState({ duration: this.audio.duration })
  }
  onPlay = e => {
    if(!this._isMounted) return

    this.setState({ playing: true, ended: false })
    this.context.playCurrent(this.props.source)
  }
  onPause = e => {
    if(!this._isMounted) return

    this.setState({ playing: false })
  }
  onEnded = e => {
    if(!this._isMounted) return

    this.setState({ ended: true })
  }
  onTimeUpdate = e => {
    if(!this._isMounted) return
    
    const currentTime = this.audio.currentTime

    this.setState(prevState => ({
      currentTime: currentTime,
      progress: getPercent(currentTime, prevState.duration),
    }), this.changeSubtitle)
  }

  changeSubtitle = () => {
    if(!this.state.subtitle) return

    const ms = this.state.currentTime * 1000
    const part = this.state.subtitle.find(item => between(item.start, item.end, ms))

    this.context.setText(part ? part.text : '')
  }

  handlePlay = e => {
    if(this.state.playing) {
      this.audio.pause()
      return
    }

    this.audio.play()
  }
  handleSeek = e => {
    const el = e.currentTarget
    const elRect = el.getBoundingClientRect()
    const width = elRect.width
    const mousePosition = e.pageX - elRect.left
    const percent = mousePosition / width * 100
    const seconds = percent / 100 * this.state.duration

    this.audio.currentTime = seconds
  }
  handleMute = e => {
    this.setState(prevState => ({
      muted: !prevState.muted
    }), () => {
      this.audio.muted = this.state.muted
    })
  }

  render() {
    return (
      <div className={`audioplayer-el ${styles.base}`}>
        <div className={`audioplayer-ui-el ${styles.ui}`}>
          <div className={`${styles.col} ${styles.colPlay}`}>
            <div className={styles.uiButton} onClick={this.handlePlay}>
              <Icon name={this.state.playing
                ? icons.pause
                : this.state.ended
                  ? icons.replay
                  : icons.play} />
            </div>
          </div>
          {this.options.progress &&
            <div className={`${styles.col} ${styles.colProgress}`}>
              <div className={styles.uiProgress} onClick={this.handleSeek}>
                <div style={{ width: `${this.state.progress}%` }} />
              </div>
            </div>
          }
          {this.options.time &&
            <div className={`${styles.col} ${styles.colTimer}`}>
              <div className={styles.uiTimer}>{convertSeconds(this.state.currentTime)}</div>
            </div>
          }
          {this.options.volume &&
            <div className={`${styles.col} ${styles.colVolume}`}>
              <div className={styles.uiButton} onClick={this.handleMute}>
                <Icon name={this.state.muted ? icons.muted : icons.volume} />
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default PlayerControls
